import React, {useState, useEffect} from 'react'


const Slider = props => {

    const [value, setValue] = useState(2);
    const [initial, setInitial] = useState(true);

    useEffect(()=>{
        if(initial) setInitial(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    return (
        <div className={`Slider ${props.class || ''} ${initial? 'initial' : ''}`}>
            <div className={`labels`}>
               {
                    props.labels && props.labels.map((option, optionIndex) => {
                        return <div className={`label ${optionIndex === value ? 'current' : ''}`} key={`option-${optionIndex}`}>{option}</div>                                             
                    })
                }
               </div>           
            <input type={'range'} className={'range'} value={value} disabled={props.disabled} onChange={e=>setValue(parseInt(e.currentTarget.value))} min={0} max={props.labels ? props.labels.length - 1 : 5} step={1} list="options"/>
            
            
        </div>
    )
}

export default Slider